import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import SVGLoader from "./SVGLoader";

const translateBrand = b => {
  if (b === "B") return "Bohn";
  else if (b === "L") return "Larkin";
  else if (b === "C") return "Climate Control";
  else if (b === "H") return "Chandler";
  else if (b === "M") return "M - Series";
  else return "";
};
const translateImagePath = b => {
  if (b === "B") return "./preload/bohn.svg";
  else if (b === "L") return "./preload/larkin.svg";
  else if (b === "C") return "./preload/climate-control.svg";
  else if (b === "H") return "./preload/chandler.svg";
  else if (b === "M") return "./preload/oem.svg";
  else return "";
};

const ModelList = props => {
  let difbrand = false;

  const [showA2l, setShowA2l] = useState(false);
  const [toggle, setToggle] = useState(props.toggleOn);
  const [isLegacyModel, setIsLegacyModel] =  useState((props.doe && props.doe.length > 0));

  //Handle Model number change
  useEffect(() => {
    setToggle(false);
    props.handleToggleChange(false);
    if(!(props.doe && props.doe.length > 0)) {
      setShowA2l(true);
      setIsLegacyModel(false);
    }
    else{
      setShowA2l(false);
      setIsLegacyModel(true);
    }
  }, [props.modelNumber, props.doe]);

  //Handle Toggle change
  useEffect(() => {
      if(isLegacyModel && showA2l) { 
        props.setModel(props?.doe.length); 
      }
      else {
        props.setModel(0); 
      }
  }, [showA2l]);

  useEffect(() => {
    if (isLegacyModel && !props.toggleOn) {
      setToggle(false);
      setShowA2l(false);
    } else {
      setToggle(true);
      setShowA2l(true);
    }
  }, [props.toggleOn]);


  //Show A2L Models based on toggle
  const showA2lModels = () => {
    setToggle(!toggle);
    setShowA2l((prevShowA2l) => !prevShowA2l);
    props.handleToggleChange(!toggle);
  };
  
  if (
    props.doe.length == 2 &&
    props.doe[0].modelno[0] != props.doe[1].modelno[0]
  ) {
    difbrand = true;
  }
  const doelist = props.doe.map((doe, index) => {
    if (typeof doe.compliant_flag === "undefined") {
      doe.compliant_flag = "";
    }
    let optionhead = (
      <small id="emailHelp" className="form-text text-muted">
        Option {index + 1}.
        <div
          className={doe.compliant_flag
            .replace(" ", "_")
            .replace("-1", "")
            .replace("-2", "")}
            style={{height:"11px",width:"14%"}}
        >
          {/* {doe.compliant_flag} */}
        </div>
      </small>
    );
    if (difbrand == true) {
      optionhead = (
        <small id="emailHelp" className="form-text text-muted">
          {translateBrand(doe.modelno[0])} Option
        </small>
      );
    }
    let modelno = doe.modelno;
    if (doe.modelno.toUpperCase().startsWith("M"))
      modelno = modelno.replace("M", "⍦");

    return (
      <React.Fragment key={index}>
        <Form.Group controlId="notaform">
          {optionhead}
          <a
            onClick={() => {
              props.setModel(index);
            }}
            className={"new-brand-one select_btn_" + index}
            key={doe.modelno}
          >
            <div className={"modelno_disply "}>{modelno}</div>
          </a>
        </Form.Group>
      </React.Fragment>
    );
  });

  let startIndex = props.doe.length || 0; // Start index from the length of doelist
  const a2llist = props.a2l.map((a2l, index) => {
    if (typeof a2l.compliant_flag === "undefined") {
      a2l.compliant_flag = "";
    }
    let optionhead = (
      <small id="emailHelp" className="form-text text-muted">
        Option {(index + 1)}.
        <div
          className={a2l.compliant_flag
            .replace(" ", "_")
            .replace("-1", "")
            .replace("-2", "")}
            style={{height:"11px",width:"14%"}}
        >
          {/* {doe.compliant_flag} */}
        </div>
      </small>
    );
    if (difbrand == true) {
      optionhead = (
        <small id="emailHelp" className="form-text text-muted">
          {translateBrand(a2l.modelno[0])} Option
        </small>
      );
    }
    let modelno = a2l.modelno;
    if (a2l.modelno.toUpperCase().startsWith("M"))
      modelno = modelno.replace("M", "⍦");

    return (
      <React.Fragment key={index}>
        <Form.Group controlId="notaform">
          {optionhead}
          <a
            onClick={() => {
              props.setModel(index);
            }}
            className={"new-brand-one select_btn_" + (index + startIndex)}
            key={a2l.modelno}
          >
            <div className={"modelno_disply "}>{modelno}</div>
          </a>
        </Form.Group>
      </React.Fragment>
    );
  });

  var legacy_nochange_msg = "Click on model to determine if it meets DOE minimum AWEF";  
  var compliant_legend =  
                            <div className="compliant-legend">
                                  <small id="emailHelp" style={{float:"left"}} className="form-text text-muted">
                                  <div className="Compliant">Meets minimum AWEF</div>
                                </small>
                                <small id="emailHelp" className="form-text text-muted">
                                  <div className="Non-Compliant">Does not meet minimum AWEF</div>
                                </small>
                            </div>

                           
                            

  if(props.legacy_nochange){
    legacy_nochange_msg = "";
  }
  return (
    <Form.Group controlId="notaform">
      <div className="brand-differents">
        <div className="clickhere_note">
          {legacy_nochange_msg}
        </div>
        {isLegacyModel && <div className="compareData-toggle">
              <p>Show A2L Models</p>
              <label className="switch">
                  <input type="checkbox" checked={props.toggleOn} onChange={showA2lModels}/>            
                  <span className="slider round"></span>
              </label>
            </div>}
        <div>
          <Link to="#" className="old-brand">
            {props.legacy.modelno}
          </Link>
          <i className="fa fa-arrow-right" aria-hidden="true" />
        </div>
        {!showA2l && <div className="listclass">{doelist}</div>}
        {showA2l && <div className="listclass">{a2llist}</div>}

        {/*<div className="tab-right-logo">
          <img src="images/tab-logo.png" alt="" />
        </div>*/}
        <div className="clickhere_note">
          {compliant_legend}
        </div>
      </div>
    </Form.Group>
  );
};
export default ModelList;
